import React, { useState } from 'react';
import { SearchBar } from '../components/SearchBar';
import { FilterSidebar } from '../components/FilterSidebar';
import { CarTypeCarousel } from '../components/CarTypeCarousel';
import { CarListingGrid } from '../components/CarListingGrid';
interface CatalogPageProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}
export function CatalogPage({
  searchQuery,
  setSearchQuery
}: CatalogPageProps) {
  const [selectedType, setSelectedType] = useState<string | null>(null);
  return <>
      <SearchBar searchQuery={searchQuery} onSearchChange={setSearchQuery} data-id="element-307" />

      <div className="max-w-[1600px] mx-auto flex" data-id="element-308">
        <FilterSidebar data-id="element-309" />

        <main className="flex-1 p-4 md:p-6 lg:p-8 min-w-0" data-id="element-310">
          <h1 className="text-2xl font-bold text-[#4A90E2] mb-6" data-id="element-311">Catálogo</h1>

          <CarTypeCarousel selectedType={selectedType} onSelectType={setSelectedType} data-id="element-312" />
          <CarListingGrid searchQuery={searchQuery} selectedType={selectedType} data-id="element-313" />
        </main>
      </div>
    </>;
}